import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://panel.masit.net/api/auth/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      });

      const data = await response.json();

      if (data.length === 0 || data.message?.includes("Keine Daten gefunden")) {
        setError('Falsche E-Mail oder Passwort');
      } else {
        setError('');
        // Handle successful login (e.g., save token, redirect)
        localStorage.setItem('user', JSON.stringify(data[0])); // Save user data to local storage
        console.log('Login successful:', data[0].users_approve);
        if (data[0].users_approve==0) {
          navigate('/verifycode', { state: { email } }); // Pass email to VerifyCode component
        }else{
          navigate("/"); // Redirect to the home page
        
        window.location.reload(); // Refresh the page
        }
      }
    } catch (error) {
      setError('An error occurred during login');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Sign In</h2>
        <form onSubmit={handleSignIn}>
          <div className="mb-4">
            <label className="block text-gray-700 dark:text-gray-300 mb-2" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border rounded-md text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 dark:text-gray-300 mb-2" htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded-md text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-700 border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500"
              required
            />
          </div>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <button
            type="submit"
            className="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Sign In
          </button>
        </form>
        <p className="mt-4 text-gray-600 dark:text-gray-400">
          Forget Password? <a href="/forgetpassword" className="text-red-600 hover:text-red-500">reset</a>
        </p>
        <p className="mt-4 text-gray-600 dark:text-gray-400">
          Don&apos;t have an account? <a href="/register" className="text-red-600 hover:text-red-500">Register</a>
        </p>
      </div>
    </div>
  );
};

export default SignIn;